import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { noop, map } from 'lodash';
export class SliderFakeDataFeed extends React.Component {
  static getFakeItemIds(totalItemsCount) {
    return map(Array(totalItemsCount), (_, index) => `item-${index}`);
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "loadMoreItems", (itemsCount, isInitial) => {
      const {
        totalItemsCount
      } = this.props;
      const fakeItemIds = SliderFakeDataFeed.getFakeItemIds(totalItemsCount);
      const nextItemsCursor = Math.min(this.state.nextItemsCursor + itemsCount, totalItemsCount - 1);
      if (!isInitial) {
        this.props.onLoadMore(itemsCount);
      }
      if (nextItemsCursor !== totalItemsCount - 1) {
        this.setState({
          isFetching: true
        });
        setTimeout(() => {
          this.setState({
            itemIds: [...this.state.itemIds, ...fakeItemIds.slice(this.state.nextItemsCursor, nextItemsCursor)],
            nextItemsCursor,
            isFetching: false
          });
        }, 300);
      }
    });
    this.state = {
      nextItemsCursor: 0,
      itemIds: [],
      isFetching: false
    };
  }
  componentDidMount() {
    this.loadMoreItems(this.props.initialLoadItemsCount, true);
  }
  render() {
    const {
      nextItemsCursor,
      isFetching,
      itemIds
    } = this.state;
    return this.props.children({
      ...this.props,
      canLoadMoreItems: Boolean(nextItemsCursor && !isFetching),
      itemIds,
      loadMoreItems: this.loadMoreItems,
      itemsCount: this.props.totalItemsCount,
      ...(this.props.renderItem && {
        renderItem: this.props.renderItem.bind(this)
      })
    });
  }
}
_defineProperty(SliderFakeDataFeed, "defaultProps", {
  onLoadMore: noop,
  totalItemsCount: 200,
  initialLoadItemsCount: 3
});
//# sourceMappingURL=slider-fake-data-feed.js.map